<div
  class="card-container relative w-full max-w-sm mx-auto rounded-lg shadow-lg overflow-hidden transition-all duration-300"
  [ngClass]="{
    'bg-black': darkMode, 
    'bg-white': !darkMode,
    'cursor-pointer': clickable(), 
    }"
  (mouseenter)="isHovered = additionalInfo() && imageUrl() ? true : false"
  (mouseleave)="isHovered = false"
  (click)="clickable() ? handleClick() : null"
>

  <div *ngIf="imageUrl()"
       class="relative overflow-hidden transition-all duration-300 h-[500px]">
    <img
      [src]="imageUrl()"
      [alt]="title()"
      class="w-full h-full object-cover transition-all duration-300"
      [ngClass]="{'opacity-50': isHovered}"
    />
  </div>

  <div
    class="absolute bottom-0 w-full bg-white/80 p-6 rounded-b-lg transition-all overflow-hidden duration-300 flex flex-col justify-between border-transparent backdrop-blur-md backdrop-filter"
    [ngClass]="{
      'h-[150px]': imageUrl() && !isHovered,
      'h-[250px] bg-white/60': imageUrl() && isHovered,
      'relative h-auto min-h-[150px]': !imageUrl(),
      'bg-black/80': darkMode,
      'bg-white/80': !darkMode 
    }"
      style="overflow-y: scroll; -ms-overflow-style: none; scrollbar-width: none;"
  >
    <div>
      <ui-label
        [tag]="ELabelType.SUBTITLE"
        [type]="EAlert.DARK"
        class="text-xl font-semibold mb-2"
      >{{title()}}</ui-label>

      <ui-label
        *ngIf="subtitle"
        [tag]="ELabelType.PARAGRAPH"
        [type]="EAlert.DARK"
        class="text-gray-600 mb-2"
      >{{subtitle()}}</ui-label>
    </div>

    <div *ngIf="additionalInfo"
         class="transition-all duration-300 break-words whitespace-normal"
         [ngClass]="{
           'opacity-0': imageUrl() && !isHovered,
           'opacity-100': isHovered || !imageUrl()
         }">
      <ui-label
        [tag]="ELabelType.PARAGRAPH"
        [type]="EAlert.DARK"
        class="text-gray-800 text-sm"
      >{{additionalInfo()}}</ui-label>
    </div>

    <div *ngIf="buttons()?.length" class="flex flex-wrap gap-4 mt-10">
      <div *ngFor="let button of buttons()" class="flex justify-center items-center">
        <ui-button
          [icon]="button.icon"
          [iconFIll]="button.iconFill || false"
          [size]="button.size"
          [disabled]="button.disabled || false"
          [type]="button.type"
          [text]="button.text"
          class="hover:scale-110 transition-transform duration-300"
          (action)="sendAction($event, button.name)"></ui-button>
      </div>
    </div>
  </div>
</div>
